module.exports = __webpack_public_path__ + "static/media/van rear.03123735.png";